import React, { useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';
import Tooltip from '../../../components/ui/Tooltip';
import {
  Card, CardHeader, CardTitle, CardMeta, HeaderRight, ExportBtn, EmptyState, Skeleton, Stale,
} from '../styles';
import { exportCardPng } from '../exportCardPng';

// Devam Paneli kart kabuğu (İzin Paneli kabuğu + başarısızlık durumu + soluk yeniden yükleme):
// - iskelet YALNIZ ilk yüklemede (loading && data == null);
// - yeniden yüklemede önceki çizim Stale içinde %50 opaklıkla kalır;
// - GET başarısızsa (api.js GET'te reddetmez — res.data.status === false) "Veri yok" DEĞİL "Veriler yüklenemedi".
export default function DashboardCard({
  cardKey,
  title,
  meta,
  span,
  spanMd,
  slice,
  empty,
  emptyText,
  headerExtra,
  domId,
  children,
}) {
  const { t } = useTranslation();
  const cardRef = useRef(null);
  const state = slice || { data: null, loading: false, failed: false };

  const handleExport = useCallback(() => {
    exportCardPng(cardRef.current, cardKey).catch(() => {});
  }, [cardKey]);

  let body;
  if (state.loading && state.data == null) body = <Skeleton data-state="loading" />;
  else if (state.failed) body = <EmptyState data-state="failed">{t('attendanceDashboard.loadFailed')}</EmptyState>;
  else if (empty) body = <EmptyState data-state="empty">{emptyText || t('attendanceDashboard.empty')}</EmptyState>;
  else body = <Stale $stale={state.loading} data-stale={state.loading ? '1' : undefined}>{children}</Stale>;

  return (
    <Card ref={cardRef} id={domId} $span={span} $spanMd={spanMd}>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <HeaderRight>
          {meta ? <CardMeta>{meta}</CardMeta> : null}
          {headerExtra}
          <span data-export-exclude>
            <Tooltip text={t('attendanceDashboard.export.saveAsPng')}>
              <ExportBtn type="button" onClick={handleExport} aria-label={t('attendanceDashboard.export.saveAsPng')}>
                <Download size={15} />
              </ExportBtn>
            </Tooltip>
          </span>
        </HeaderRight>
      </CardHeader>
      {body}
    </Card>
  );
}
